export class LoginSkin{
    htmlskin() {
        return`
            <div class="login-container">
                <div class="login-card">
                    <h1 class="login-title">Welcome</h1>
                    <p class="login-subtitle">Fill in your login credentials below</p>
                    <form id="loginForm" class="d-flex flex-column gap-20">
                        <div class="input-group">
                            <input name="username" type="text" placeholder="Username" required />
                        </div>
                        <div class="input-group appended-icon">
                            <input type="password" name="password" placeholder="Password" required />
                            <div class="input-icon">
                                <span class="iconify" data-icon="iconoir:eye" data-inline="false"></span>
                            </div>
                        </div>
                        <div class="login-footer d-flex align-items-center justify-space-between">
                            <div class="label-group">
                                <span class="iconify" data-icon="material-symbols:lock" data-inline="false"></span>
                                <label for="rememberMe">Forget password</label>
                            </div>
                            <button type="submit" class="login-button">Login</button>
                        </div>
                    </form>
                </div>
                <div class="mini-sites-overview">
                    <div class="mini-site-cards">
                        <div class="total-site-overview">
                            <div class="overview-reading">
                                <span class="overview-label">Overview</span>
                                <h3 class="overview-value">62 Sites</h3>
                            </div>
                            <div class="overview-progress-bar">
                                <div class="progress-bar-fill" style="height: 100%;">
                                    <div class="inner-fill" style="height: 80%;"></div>
                                </div>
                                <div class="progress-bar-fill" style="height: 100%;">
                                    <div class="inner-fill" style="height: 50%;"></div>
                                </div>
                                <div class="progress-bar-fill" style="height: 100%;">
                                    <div class="inner-fill" style="height: 40%;"></div>
                                </div>
                                <div class="progress-bar-fill" style="height: 100%;">
                                    <div class="inner-fill" style="height: 70%;"></div>
                                </div>
                                <div class="progress-bar-fill" style="height: 100%;">
                                    <div class="inner-fill" style="height: 90%;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="overview-card">
                            <div class="overview-heading">
                                <div class="tip-bar d-flex align-items-center justify-space-between">
                                    <span class="tip-text">Total Capacity</span>
                                    <span class="iconify" data-icon="tabler:dots" data-inline="false"></span>
                                </div>
                                <div class="overview-content d-flex align-items-center justify-space-between">
                                    <h3 class="overview-total">150 MW</h3>
                                    <!-- absolute line graph -->
                                    <img src="/assets/overviewgraph.png" alt=""> 
                                </div>
                            </div>
                            <div class="overview-table-reading">
                                <p class="mini-heading">Readings</p>
                                <div class="reading-list">
                                    <div class="reading-item">
                                        <div class="reading-block-content d-flex align-items-center gap-10">
                                            <div class="reading-icon icon-blue">
                                                <span class="iconify" data-icon="icon-park-outline:car-battery" data-inline="false"></span>
                                            </div>
                                            <div class="reading-block">
                                                <span class="reading-device">BESS</span>
                                                <span class="reading-time">Today 16:36</span>
                                            </div>
                                        </div>
                                        <h3 class="reading-value">60 MW</h3>
                                    </div>
                                    <div class="reading-item">
                                        <div class="reading-block-content d-flex align-items-center gap-10">
                                            <div class="reading-icon icon-green">
                                                <span class="iconify" data-icon="mdi:generator-stationary" data-inline="false"></span>
                                            </div>
                                            <div class="reading-block">
                                                <span class="reading-device">Generator</span>
                                                <span class="reading-time">Today 16:36</span>
                                            </div>
                                        </div>
                                        <h3 class="reading-value">55 MW</h3>
                                    </div>
                                    <div class="reading-item">
                                        <div class="reading-block-content d-flex align-items-center gap-10">
                                            <div class="reading-icon icon-yellow">
                                                <span class="iconify" data-icon="flowbite:sun-solid" data-inline="false"></span>
                                            </div>
                                            <div class="reading-block">
                                                <span class="reading-device">PV</span>
                                                <span class="reading-time">Today 16:36</span>
                                            </div>
                                        </div>
                                        <h3 class="reading-value">35 MW</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mini-map-reading">
                        <canvas id="waveform-chart" class="chart-canvas"></canvas>
                    </div>
                </div>
            </div>
        `;
    }
}